var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _g3, _path16, _path17, _path18, _path19, _path20, _path21, _g4, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g5, _path40, _path41, _g6, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 392,
    viewBox: "0 0 459 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.049 248.448H325.691V251.054H340.049V248.448Z",
    fill: "#4598E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter0_d_362_3307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.987 198.477H79.2379C69.3821 198.477 61.3818 190.625 61.3818 180.952V58.5183C61.3818 48.8454 69.3821 40.9937 79.2379 40.9937H203.987C213.843 40.9937 221.843 48.8454 221.843 58.5183V180.952C221.812 190.655 213.843 198.477 203.987 198.477Z",
    fill: "#FFD255",
    fillOpacity: 0.56,
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.641 162.134H104.582V166.172H178.641V162.134Z",
    fill: "#96BFE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.356 174.249H114.869V178.287H168.356V174.249Z",
    fill: "#96BFE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.546 85.896C196.713 89.4782 182.837 76.3063 172.534 68.3397C158.924 57.8358 148.603 63.265 148.603 63.265L163.429 90.7841C185.156 110.878 206.939 105.934 220.606 99.0306C220.72 93.6387 219.238 89.1796 217.546 85.896Z",
    fill: "#D44040"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.665 72.6494L239.803 76.5674C231.591 81.866 224.216 84.7392 217.544 85.8773C219.217 89.1609 220.718 93.6386 220.604 98.9931C229.31 94.6087 234.708 89.4221 234.708 89.4221C250.238 79.6272 246.665 72.6494 246.665 72.6494Z",
    fill: "url(#paint0_linear_362_3307)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.162 81.495C245.959 80.0145 245.096 78.7127 243.817 77.9258C241.331 76.3892 237.255 74.4712 235.547 77.0908C233.006 80.9942 239.831 89.696 239.831 89.696L245.427 94.2599L246.616 97.8833C247.936 94.9118 247.36 88.7245 246.162 81.495Z",
    fill: "url(#paint1_linear_362_3307)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.871 132.072C107.887 135.318 103.439 138.173 100.303 139.964C105.131 145.598 111.632 151.233 120.205 156.681L122.733 161.961L130.317 152.688C130.317 152.688 116.27 146.158 110.871 132.072Z",
    fill: "url(#paint2_linear_362_3307)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.107 80.2423C178.541 77.2198 176.298 73.9549 174.397 70.5966C171.755 65.895 174.245 73.675 173.447 68.3205C154.02 55.0926 125.28 62.4994 114.141 64.0853C110.491 64.6077 107.165 66.4361 104.808 69.2346C95.4554 80.2796 75.0214 110.429 100.322 139.963C103.458 138.191 107.887 135.336 110.89 132.072C108.001 124.553 107.602 114.888 113.095 102.929C113.304 103.862 113.57 104.795 113.875 105.709C122.238 130.131 123.056 150.561 123.132 155.262C123.151 155.897 123.55 156.475 124.158 156.699C134.632 160.598 154.591 157.8 161.3 156.68C162.536 156.475 163.334 155.337 163.144 154.124C159.4 130.747 175.576 91.8656 179.853 82.1267C180.138 81.4177 180.575 80.7833 181.107 80.2423Z",
    fill: "#D44040"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.722 44.0292L130.106 64.1601C130.106 64.1601 141.683 67.3505 149.951 61.3989L143.716 43.2456L131.722 44.0292Z",
    fill: "url(#paint3_linear_362_3307)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.631 20.8766C144.916 21.1191 156.758 42.9292 156.758 42.9292L143.927 49.3099L129.576 30.2797C129.595 30.2797 139.917 16.6787 144.631 20.8766Z",
    fill: "url(#paint4_linear_362_3307)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.317 30.7086C135.089 31.3057 135.165 31.9587 135.507 32.4811L142.16 42.929C142.255 43.0783 142.388 43.2275 142.521 43.3581C143.301 44.0484 145.981 46.0447 147.958 43.2275C149.649 40.8208 151.227 38.6379 152.957 37.7237C153.964 37.1827 155.219 37.5745 155.751 38.5633C156.854 40.6155 159.001 44.7947 160.37 48.7687C160.712 49.7575 160.199 50.8583 159.23 51.2687C156.625 52.3508 151.493 54.3471 146.893 55.0561C146.133 55.168 145.391 54.8695 144.916 54.2725C142.882 51.6418 137.18 44.3283 135.241 42.4999C133.435 40.8021 130.185 41.5111 128.721 41.9588C128.17 42.1268 127.562 42.0708 127.067 41.7723C125.566 40.9141 122.924 38.7685 125.224 35.0184C125.794 34.0856 125.471 32.8542 124.539 32.2758C122.848 31.231 121.004 29.2534 122.657 25.9511C124.33 22.6115 127.448 22.257 129.558 22.4809C130.489 22.5742 131.439 22.0705 131.781 21.2122C131.934 20.8204 132.238 20.5033 132.827 20.3727C133.929 20.1301 134.652 19.1226 134.405 18.0405C133.986 16.1748 134.234 13.7308 137.237 12.033C142.768 8.91724 147.749 13.7308 149.079 17.854C150.41 21.9772 144.213 25.0183 140.297 25.578C137.446 25.9511 135.925 29.0668 135.317 30.7086Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.751 46.3058C137.751 46.3058 135.128 39.2161 131.954 39.5333C128.779 39.8505 126.346 43.0035 130.338 46.4364C135.337 50.6902 137.751 46.3058 137.751 46.3058Z",
    fill: "url(#paint5_linear_362_3307)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.993 101.12C107.583 89.9443 108.838 76.3247 108.857 76.1941L110.016 76.306C109.997 76.4366 108.781 89.7951 113.077 100.709L111.993 101.12Z",
    fill: "#D44040"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.302 14.2531L121.649 36.9213C121.212 37.2572 120.584 36.996 120.508 36.4736L120.204 34.4027C120.204 34.4027 107.868 22.2196 120.546 11.212C133.225 0.20431 148.184 12.6672 148.184 12.6672L151.055 13.2269C151.549 13.3202 151.701 13.9545 151.302 14.2531Z",
    fill: "#D44040"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M178.107 57.9058V60.109H191.394V72.3458H193.639V57.9058H178.107ZM87.9473 72.3458H90.1922V60.109H103.479V57.9058H87.9473V72.3458ZM191.394 135.465V147.702H178.107V149.905H193.639V135.465H191.394ZM90.1922 135.465H87.9473V149.905H103.479V147.702H90.1922V135.465Z",
    fill: "#4598E6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter1_d_362_3307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.598 350.2H260.594C250.974 350.2 243.191 342.598 243.191 333.2V158.748C243.191 149.35 250.974 141.748 260.594 141.748H407.598C417.219 141.748 425.001 149.35 425.001 158.748V333.2C425.001 342.598 417.219 350.2 407.598 350.2Z",
    fill: "#FFD255",
    fillOpacity: 0.56,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_3307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.583 258.836H365.28C364.338 252.04 363.191 244.283 363.191 244.283C363.191 244.283 362.615 250.685 361.911 258.836H304.681C304.161 251.505 303.531 246.022 303.305 245.908C302.975 245.746 300.934 252.249 299.24 258.836H283.724C287.709 241.802 295.142 214.473 299.439 212.827C305.557 210.502 330.504 202.867 330.504 202.867H344.738C344.738 202.867 370.036 210.029 372.39 217.813C374.261 224.025 378.389 244.486 379.583 258.836Z",
    fill: "#E65353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.276 157.049C338.276 157.049 351.568 159.122 349.555 179.763C347.541 200.405 335.799 198.71 335.016 198.689C334.232 198.668 323.238 199.064 322.379 173.867C322.369 173.867 321.995 155.236 338.276 157.049Z",
    fill: "#EEA987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.481 192.61C344.481 192.61 344.116 201.107 344.945 202.935C345.774 204.763 333.975 210.674 326.773 204.098C326.773 204.098 328.511 194.873 328.027 191.603C327.542 188.333 344.481 192.61 344.481 192.61Z",
    fill: "#EEA987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.751 173.933C349.751 173.933 351.213 172.391 351.74 173.954C352.266 175.517 349.482 182.495 349.664 182.808C349.664 182.808 349.398 183.413 349.049 183.079C348.701 182.745 349.751 173.933 349.751 173.933Z",
    fill: "#EEA987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.518 173.674C322.518 173.674 321.094 172.103 320.53 173.654C319.966 175.204 322.619 182.236 322.433 182.547C322.433 182.547 322.686 183.156 323.043 182.83C323.4 182.505 322.518 173.674 322.518 173.674Z",
    fill: "#EEA987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.744 177.1L347.839 179.624C347.839 179.624 347.894 174.089 347.589 173.222C347.284 172.356 346.816 169.699 346.561 169.078C346.306 168.456 335.147 165.347 325.288 169.983C325.288 169.983 325.722 173.964 324.776 174.317C323.83 174.669 324.296 180.799 324.296 180.799L322.731 179.048C322.731 179.048 320.336 163.171 320.927 161.515C321.518 159.859 323.404 149.909 343.627 155.818C343.627 155.818 349.932 154.494 351.196 158.813C352.46 163.132 349.744 177.1 349.744 177.1Z",
    fill: "#D98B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.945 202.935C344.945 202.935 347.944 203.569 335.391 215.509C335.391 215.509 326.491 205.737 326.779 204.11C327.068 202.483 344.945 202.935 344.945 202.935Z",
    fill: "#EEA987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.392 215.505L338.817 221.316L348.978 204.199L344.578 201.155L335.392 215.505Z",
    fill: "#B84343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.391 215.505L327.08 202.382L322.368 205.387L330.817 221.316L335.391 215.505Z",
    fill: "#B84343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.816 251.86C332.918 253.795 332.964 256.168 332.968 258.836H332.498C332.498 256.181 332.448 253.812 332.346 251.882C331.575 237.323 335.13 219.61 335.151 215.457L335.61 215.548C335.587 219.699 332.045 237.363 332.816 251.86Z",
    fill: "#B84343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.271 196.258C329.271 196.258 332.43 199.574 336.891 198.689C341.352 197.804 343.332 195.787 343.332 195.787C343.332 195.787 341.572 200.169 336.413 200.571C331.254 200.973 329.271 196.258 329.271 196.258Z",
    fill: "#C78D71"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M354.732 289.003H271.244V294.045H354.732V289.003Z",
    fill: "#96BFE6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.746 313.25H271.244V318.291H338.746V313.25Z",
    fill: "#96BFE6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M310.808 301.126H271.244V306.167H310.808V301.126Z",
    fill: "#96BFE6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M376.558 162.972V165.529H391.867V179.62H394.473V162.972H376.558ZM272.674 179.62H275.28V165.529H290.589V162.972H272.699V179.62H272.674ZM391.842 252.313V266.404H376.533V268.961H394.423V252.313H391.842ZM275.28 252.313H272.674V268.961H290.564V266.404H275.255V252.313H275.28Z",
    fill: "#4598E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M386.353 318.685C377.909 318.685 371.044 311.947 371.044 303.659C371.044 295.372 377.909 288.634 386.353 288.634C394.798 288.634 401.663 295.372 401.663 303.659C401.638 311.947 394.772 318.685 386.353 318.685ZM386.353 291.56C379.538 291.56 374.026 296.995 374.026 303.659C374.026 310.348 379.563 315.758 386.353 315.758C393.144 315.758 398.681 310.324 398.681 303.659C398.681 296.971 393.144 291.56 386.353 291.56Z",
    fill: "#4598E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M385.377 309.561L378.411 302.749L380.516 300.684L385.377 305.454L392.192 298.765L394.272 300.831L385.377 309.561Z",
    fill: "#4598E6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter2_d_362_3307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.447 128.407H288.541C281.33 128.407 275.476 122.586 275.476 115.419V47.3509C275.476 40.1831 281.33 34.3625 288.541 34.3625H367.447C374.657 34.3625 380.512 40.1831 380.512 47.3509V115.419C380.512 122.586 374.657 128.407 367.447 128.407Z",
    fill: "#292743"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M386.577 94.855C386.577 94.855 388.259 98.1046 389.897 97.7052C391.514 97.3058 393.929 97.4148 394.684 97.4874C395.697 97.5782 398.975 96.9246 398.781 97.9594C398.587 98.9942 393.412 99.2302 392.334 99.4662C391.256 99.6841 395.137 102.008 395.417 102.897C395.697 103.787 390.264 108.943 387.849 107.091C385.434 105.239 384.421 101.935 383.903 101.681C383.386 101.427 381.165 98.7763 381.165 98.7763L386.577 94.855Z",
    fill: "#E2A18D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M394.968 102.352C394.968 102.352 401.889 108.416 401.933 109.142C401.954 109.868 401.501 110.177 400.833 109.632C400.165 109.088 393.912 103.932 393.912 103.932C393.912 103.932 400.553 112.283 400.747 112.864C400.855 113.209 400.035 113.826 399.626 113.572C399.237 113.318 392.036 105.366 392.036 105.366C392.036 105.366 398.224 113.172 398.181 113.699C398.159 114.171 397.232 114.588 396.715 114.044C396.197 113.499 389.945 106.528 389.945 106.528C389.945 106.528 393.998 112.446 393.632 112.9C393.416 113.172 392.726 113.735 391.734 112.174C390.742 110.613 387.939 107.163 387.939 107.163L394.968 102.352Z",
    fill: "#E2A18D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M338.064 31.5442C338.064 31.5442 359.949 35.4655 361.781 40.585C363.614 45.7045 367.15 57.7409 372.088 70.812C375.041 78.6365 390.026 96.4641 390.026 96.4641C390.026 96.4641 381.445 101.783 381.445 101.075C381.445 100.367 361.264 77.6743 361.005 74.9149C360.768 72.1554 354.645 58.0132 354.645 58.0132C354.645 58.0132 351.734 85.1902 351.734 89.3839C351.734 93.5775 352.057 102.092 352.057 102.092C352.057 102.092 343.95 104.706 328.189 104.016C328.189 104.016 303.135 103.29 307.404 96.8635C310.638 91.9981 308.655 59.284 308.18 59.0661C307.685 58.8664 298.952 68.0707 299.815 69.8498C300.656 71.6289 323.273 77.9829 323.273 77.9829C323.273 77.9829 323.942 80.0344 320.427 84.6819C320.427 84.6819 286.641 76.3672 286.533 74.6244C286.404 72.8816 300.591 39.06 305.205 37.2991C311.867 34.7575 329.289 30.7454 329.289 30.7454L338.064 31.5442Z",
    fill: "#E4B63D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3 85.3639H328.216C329.432 85.3639 330.427 86.3404 330.427 87.534H334.462C334.462 87.154 334.131 86.8286 333.743 86.8286H332.527C332.196 84.8212 330.371 83.1934 328.16 83.1934L322.245 83.1937C320.034 83.1937 318.21 84.767 317.878 86.8289H316.717C316.33 86.8289 315.998 87.1544 315.998 87.5344H320.034C320.089 86.3407 321.084 85.3639 322.3 85.3639L322.3 85.3639Z",
    fill: "#2F2661"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M328.161 101.528C328.161 102.504 327.332 103.318 326.337 103.318H324.126C323.131 103.318 322.301 102.558 322.301 101.528V100.063H303.837V112.213C303.837 113.515 304.887 114.546 306.214 114.546H344.193C345.52 114.546 346.57 113.515 346.57 112.213L346.57 100.063H328.161L328.161 101.528Z",
    fill: "#D44040"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M344.358 88.2944H306.102C304.444 88.2944 303.117 89.5248 303.117 90.9519V98.1377H322.3V96.8582C322.3 95.9725 323.129 95.1849 324.125 95.1849H326.336C327.331 95.1849 328.16 95.9724 328.16 96.8582V98.1377H347.343V90.9519C347.343 89.4754 346.016 88.2944 344.358 88.2944H344.358Z",
    fill: "#D44040"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.335 101.486C326.943 101.486 327.441 101.082 327.441 100.588V97.5823C327.441 97.0888 326.943 96.6851 326.335 96.6851H324.124C323.516 96.6851 323.019 97.0888 323.019 97.5823V100.588C323.019 101.082 323.516 101.486 324.124 101.486H326.335Z",
    fill: "#2F2661"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M337.696 25.2498C337.696 25.2498 336.79 29.4071 338.342 32.2573C338.342 32.2573 339.916 38.8837 331.874 39.1741C323.832 39.4646 323.638 33.4011 323.638 33.4011C323.638 33.4011 325.557 31.2225 324.285 25.3042C322.991 19.3678 337.696 25.2498 337.696 25.2498Z",
    fill: "#E2A18D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M332.801 1.17817C332.801 1.17817 343.107 2.57605 341.533 16.4822C339.959 30.3884 330.86 29.2447 330.256 29.2266C329.653 29.2084 321.136 29.4807 320.468 12.5065C320.489 12.5246 320.187 -0.0381718 332.801 1.17817Z",
    fill: "#E2A18D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M341.706 12.5608C341.706 12.5608 342.827 11.526 343.258 12.5789C343.668 13.6319 341.792 18.1705 341.641 18.5517C341.641 18.5517 341.426 18.9511 341.167 18.7333C340.887 18.4973 341.706 12.5608 341.706 12.5608Z",
    fill: "#E2A18D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M320.728 12.3801C320.728 12.3801 319.628 11.3272 319.176 12.362C318.744 13.4149 320.556 18.1714 320.642 18.3529C320.642 18.3529 320.836 18.7705 321.116 18.5526C321.418 18.3348 320.728 12.3801 320.728 12.3801Z",
    fill: "#E2A18D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M341.708 14.6852L340.242 16.3917C340.242 16.3917 340.285 12.67 340.048 12.071C339.811 11.49 340.328 9.45672 340.134 9.02102C339.94 8.60347 333.084 10.1647 321.851 9.20256C321.851 9.20256 323.101 12.5611 322.368 12.7971C321.635 13.0331 322.002 17.1723 322.002 17.1723L320.794 15.9923C320.794 15.9923 319.414 8.9484 319.565 7.76836C319.738 6.20709 319.112 -1.10913 334.917 0.14352C336.728 0.288755 338.474 0.851541 339.919 1.79557C341.536 2.86668 343.218 4.53688 343.067 6.82434C342.808 9.85612 341.708 14.6852 341.708 14.6852Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M325.581 27.3936C325.581 27.3936 329.829 31.5691 336.577 27.3936C336.577 27.3936 334.68 30.5706 330.713 30.6432C326.745 30.7158 325.581 27.3936 325.581 27.3936Z",
    fill: "#A77860"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M353.399 52.0862V53.5797H362.312V61.794H363.834V52.1129H353.399V52.0862ZM292.937 61.7673H294.459V53.5531H303.372V52.0596H292.964V61.7673H292.937ZM362.312 104.092V112.306H353.399V113.8H363.807V104.119H362.312V104.092ZM294.432 104.092H292.91V113.773H303.318V112.28H294.405V104.092H294.432Z",
    fill: "#4598E6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M329.22 77.8084C329.22 77.8084 331.29 77.7539 331.936 77.6813C332.583 77.6087 332.152 78.7524 331.419 78.952C330.664 79.188 329.22 77.8084 329.22 77.8084Z",
    fill: "#C98462"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M330.434 86.1769C330.434 86.1769 329.528 86.3585 329.075 86.2859C329.075 86.2859 328.277 86.0862 327.717 85.9772C327.544 85.9409 327.372 85.9228 327.264 85.9046C326.833 85.8683 325.841 85.9046 324.806 85.5597C323.771 85.2148 320.3 83.708 320.3 83.708L321.292 80.9848L322.046 78.8245C322.046 78.8245 327.932 77.4992 328.946 77.7171C329.054 77.7352 329.14 77.7715 329.226 77.7897C330.045 78.0438 330.541 78.534 330.951 78.7155C331.102 78.7882 332.568 79.5143 332.633 79.95C332.741 80.531 332.525 80.9848 332.18 81.2571C332.18 81.2571 332.331 82.419 331.813 83.0726C331.813 83.0726 331.986 84.1437 331.08 84.7972C331.08 84.7791 331.123 85.8683 330.434 86.1769Z",
    fill: "#E2A18D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M323.271 78.0984C323.271 78.0984 323.572 81.584 320.424 84.7973C320.424 84.7973 295.629 78.2799 292.675 77.2996C289.721 76.3193 303.413 45.6929 303.413 45.6929L313.482 48.5794L308.07 57.2027C308.07 57.2027 305.396 62.0318 299.812 69.9652C299.812 69.9652 303.24 72.7065 323.271 78.0984Z",
    fill: "#E4B63D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M340.736 36.4884L338.45 30.4248C338.45 30.4248 334.763 31.859 324.091 30.8605L321.676 36.6699C321.676 36.6699 330.839 43.387 340.736 36.4884Z",
    fill: "#E4B63D"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#filter3_d_362_3307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.526 375.215H44.5309C33.2006 375.215 24 366.068 24 354.804V247.841C24 236.577 33.2006 227.431 44.5309 227.431H168.526C179.856 227.431 189.057 236.577 189.057 247.841V354.804C189.057 366.068 179.856 375.215 168.526 375.215Z",
    fill: "#292743"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M198.588 322.49C198.588 322.49 201.231 327.597 203.806 326.969C206.347 326.342 210.142 326.513 211.328 326.627C212.92 326.77 218.07 325.742 217.766 327.369C217.461 328.995 209.329 329.366 207.635 329.736C205.941 330.079 212.039 333.73 212.48 335.128C212.92 336.526 204.382 344.628 200.587 341.718C196.793 338.809 195.2 333.616 194.387 333.217C193.574 332.818 190.084 328.652 190.084 328.652L198.588 322.49Z",
    fill: "#E2A18D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M211.773 334.272C211.773 334.272 222.649 343.8 222.717 344.942C222.751 346.083 222.039 346.568 220.989 345.712C219.938 344.856 210.113 336.754 210.113 336.754C210.113 336.754 220.548 349.877 220.853 350.79C221.023 351.332 219.735 352.302 219.091 351.902C218.482 351.503 207.165 339.008 207.165 339.008C207.165 339.008 216.889 351.275 216.821 352.102C216.787 352.844 215.331 353.5 214.517 352.644C213.704 351.788 203.879 340.833 203.879 340.833C203.879 340.833 210.248 350.134 209.672 350.847C209.334 351.275 208.249 352.159 206.691 349.706C205.132 347.252 200.728 341.832 200.728 341.832L211.773 334.272Z",
    fill: "#E2A18D"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_362_3307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.733 325.499C230.644 325.003 230.032 324.839 229.633 325.179L225.715 328.522C224.254 329.768 222.02 329.615 220.75 328.181C219.48 326.747 219.636 324.554 221.097 323.308L225.015 319.965C225.414 319.625 225.333 319.007 224.845 318.851C221.861 317.851 218.448 318.474 215.915 320.748C213.449 322.967 212.577 326.457 213.419 329.515L191.302 346.668C189.784 347.849 189.57 349.977 190.84 351.411L193.149 354.018C194.419 355.452 196.595 355.54 197.999 354.229L218.384 335.12C221.41 336.43 225.12 336.011 227.843 333.688C230.299 331.591 231.27 328.474 230.733 325.499L230.733 325.499Z",
    fill: "#6670CF"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M122.353 223.002C122.353 223.002 156.743 229.164 159.623 237.209C162.503 245.254 168.059 264.168 175.818 284.708C180.46 297.004 204.008 325.019 204.008 325.019C204.008 325.019 190.523 333.378 190.523 332.265C190.523 331.152 158.809 295.492 158.403 291.156C158.03 286.819 148.408 264.596 148.408 264.596C148.408 264.596 143.834 307.303 143.834 313.893C143.834 320.483 144.342 333.863 144.342 333.863C144.342 333.863 131.602 337.971 106.835 336.887C106.835 336.887 67.4643 335.745 74.1729 325.646C79.2552 318.001 76.1381 266.593 75.3927 266.251C74.6134 265.937 60.8913 280.401 62.2466 283.196C63.5679 285.992 99.1099 295.977 99.1099 295.977C99.1099 295.977 100.16 299.201 94.6375 306.504C94.6375 306.504 41.5448 293.438 41.3754 290.699C41.1721 287.961 63.4663 234.813 70.717 232.045C81.1864 228.051 108.563 221.747 108.563 221.747L122.353 223.002Z",
    fill: "#E4B63D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M111.501 288.259C111.573 287.316 110.951 286.445 110.007 286.282L105.76 285.547C104.816 285.384 103.929 285.994 103.667 286.904L98.4795 307.113C97.9245 309.118 99.3074 311.172 101.384 311.531L105.064 312.168C107.141 312.528 109.061 311.045 109.333 308.991L111.501 288.259Z",
    fill: "#414993"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M108.921 271.191L106.636 284.452L109.75 284.991L112.13 271.746L112.224 271.762C113.451 271.974 114.594 271.026 114.511 269.866L114.482 262.984C114.454 262.598 114.221 262.27 113.843 262.205L110.729 261.666C110.352 261.6 110.018 261.829 109.857 262.184L107.432 268.64C106.95 269.704 107.694 270.978 108.921 271.191L108.921 271.191Z",
    fill: "#414993"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M121.774 213.111C121.774 213.111 120.351 219.644 122.79 224.123C122.79 224.123 125.264 234.536 112.626 234.993C99.9876 235.449 99.6826 225.921 99.6826 225.921C99.6826 225.921 102.698 222.497 100.699 213.197C98.6662 203.868 121.774 213.111 121.774 213.111Z",
    fill: "#E2A18D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.081 175.284C114.081 175.284 130.277 177.48 127.803 199.333C125.33 221.186 111.032 219.388 110.083 219.36C109.135 219.331 95.7515 219.759 94.7012 193.085C94.7351 193.114 94.2607 173.372 114.081 175.284Z",
    fill: "#E2A18D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M128.075 193.171C128.075 193.171 129.836 191.545 130.514 193.199C131.158 194.854 128.21 201.986 127.973 202.585C127.973 202.585 127.634 203.213 127.228 202.871C126.787 202.5 128.075 193.171 128.075 193.171Z",
    fill: "#E2A18D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.11 192.887C95.11 192.887 93.3821 191.232 92.6705 192.858C91.9929 194.513 94.839 201.988 94.9745 202.273C94.9745 202.273 95.2794 202.929 95.7199 202.587C96.1942 202.244 95.11 192.887 95.11 192.887Z",
    fill: "#E2A18D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M128.078 196.51L125.774 199.191C125.774 199.191 125.842 193.343 125.469 192.402C125.097 191.489 125.91 188.293 125.605 187.609C125.3 186.953 114.526 189.406 96.8732 187.894C96.8732 187.894 98.8384 193.172 97.6864 193.543C96.5344 193.914 97.1104 200.418 97.1104 200.418L95.2131 198.564C95.2131 198.564 93.0446 187.495 93.2818 185.64C93.5529 183.187 92.5703 171.69 117.405 173.658C120.251 173.887 122.996 174.771 125.266 176.254C127.807 177.938 130.45 180.562 130.213 184.157C129.806 188.921 128.078 196.51 128.078 196.51Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M102.737 216.48C102.737 216.48 109.412 223.041 120.017 216.48C120.017 216.48 117.035 221.472 110.801 221.586C104.567 221.7 102.737 216.48 102.737 216.48Z",
    fill: "#A77860"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.456 295.702C108.456 295.702 111.709 295.617 112.725 295.503C113.742 295.389 113.064 297.186 111.912 297.5C110.726 297.871 108.456 295.702 108.456 295.702Z",
    fill: "#C98462"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M110.364 308.854C110.364 308.854 108.941 309.139 108.229 309.025C108.229 309.025 106.976 308.711 106.095 308.54C105.824 308.483 105.553 308.454 105.383 308.426C104.706 308.369 103.147 308.426 101.521 307.884C99.8944 307.342 94.4395 304.974 94.4395 304.974L95.998 300.695L97.1839 297.3C97.1839 297.3 106.434 295.217 108.026 295.559C108.195 295.588 108.331 295.645 108.466 295.674C109.754 296.073 110.533 296.843 111.177 297.129C111.414 297.243 113.718 298.384 113.82 299.068C113.989 299.981 113.65 300.695 113.108 301.122C113.108 301.122 113.345 302.948 112.532 303.975C112.532 303.975 112.803 305.658 111.38 306.685C111.38 306.657 111.448 308.369 110.364 308.854Z",
    fill: "#E2A18D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1064 296.159C99.1064 296.159 99.5807 301.636 94.634 306.686C94.634 306.686 55.6698 296.444 51.028 294.904C46.3862 293.363 67.9012 245.236 67.9012 245.236L83.724 249.772L75.2197 263.323C75.2197 263.323 71.0183 270.911 62.2429 283.378C62.2429 283.378 67.6301 287.686 99.1064 296.159Z",
    fill: "#E4B63D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M126.551 230.771L122.96 221.243C122.96 221.243 117.166 223.496 100.394 221.927L96.5996 231.056C96.5996 231.056 110.999 241.612 126.551 230.771Z",
    fill: "#E4B63D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M146.452 255.282V257.629H160.458V270.537H162.849V255.324H146.452V255.282ZM51.4402 270.495H53.8314V257.587H67.8377V255.24H51.4828V270.495H51.4402ZM160.458 337.005V349.913H146.452V352.26H162.807V337.047H160.458V337.005ZM53.7888 337.005H51.3975V352.218H67.7523V349.871H53.7461V337.005H53.7888Z",
    fill: "#4598E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_362_3307",
    x: 37.3818,
    y: 21.9937,
    width: 208.461,
    height: 205.483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_362_3307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_362_3307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_362_3307",
    x: 209.191,
    y: 115.748,
    width: 249.809,
    height: 276.452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_362_3307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_362_3307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_362_3307",
    x: 251.476,
    y: 15.3625,
    width: 153.036,
    height: 142.044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_362_3307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_362_3307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_362_3307",
    x: 0,
    y: 208.431,
    width: 213.057,
    height: 195.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_362_3307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_362_3307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_362_3307",
    x: 190.01,
    y: 318.389,
    width: 40.8667,
    height: 36.7666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.852113,
    dy: 0.340845
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.313726 0 0 0 0 0.611765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_362_3307"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_362_3307",
    x1: 267.918,
    y1: 35.2766,
    x2: 174.608,
    y2: 161.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_362_3307",
    x1: 223.948,
    y1: 76.4182,
    x2: 326.525,
    y2: 133.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_362_3307",
    x1: 100.45,
    y1: 147.323,
    x2: 130.205,
    y2: 146.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_362_3307",
    x1: 143.908,
    y1: 38.4181,
    x2: 129.489,
    y2: 107.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_362_3307",
    x1: 140.956,
    y1: 25.1067,
    x2: 149.553,
    y2: 71.3418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_362_3307",
    x1: 134.782,
    y1: 72.7928,
    x2: 132.804,
    y2: 40.2841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_3307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.8598,
    height: 104.872,
    fill: "white",
    transform: "translate(283.724 153.965)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutHeader);
export default __webpack_public_path__ + "static/media/aboutHeader.f169af108ddbcc68497316300df935eb.svg";
export { ForwardRef as ReactComponent };